export default function buildRequisitionQuery(rawS: any) {
  return {
    name: rawS._type,
    props: {
      title: rawS.title,
    },
  };
}
